export const CompanyType = {
  UNSPECIFIED: 'UNSPECIFIED',
  SMALL_MEDIUM_ENTERPRISE: 'SMALL_MEDIUM_ENTERPRISE',
} as const;

export type CompanyType = (typeof CompanyType)[keyof typeof CompanyType];
